var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 450 450",
    style: {
      enableBackground: "new 0 0 450 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M158.9,81.8h132.3c42.5,0,77.4,35,77.4,77.4v131.6c0,42.5-35,77.4-77.4,77.4H158.9 c-42.5,0-77.4-35-77.4-77.4V159.3C81.5,116.8,116.4,81.8,158.9,81.8L158.9,81.8z M302.1,131.9L302.1,131.9 c8.9,0,16.4,7.5,16.4,16.4l0,0c0,8.9-7.5,16.4-16.4,16.4l0,0c-9.6,0-16.4-7.5-16.4-16.4l0,0C285.6,139.4,292.6,131.9,302.1,131.9 L302.1,131.9z M224.7,146.9h0.7c42.5,0,78.1,35.6,78.1,78.1l0,0c0,43.2-35.6,78.1-78.1,78.1h-0.7c-42.5,0-77.4-35-77.4-78.1l0,0 C147.2,182.6,182.2,146.9,224.7,146.9L224.7,146.9z M224.7,173.7h0.7c28.1,0,51.4,23.3,51.4,51.4l0,0c0,28.8-23.3,52.1-51.4,52.1 h-0.7c-28.1,0-51.4-23.3-51.4-52.1l0,0C173.2,197,196.6,173.7,224.7,173.7L224.7,173.7z M159.6,106.5h130.9 c29.5,0,53.5,24,53.5,53.5v130.2c0,29.5-24,53.5-53.5,53.5H159.6c-29.5,0-53.5-24-53.5-53.5V159.9 C106.2,130.5,130.1,106.5,159.6,106.5L159.6,106.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0927edef03304c2a7b9d61f696ad0462.svg";
export { ForwardRef as ReactComponent };